export const enum ReportsEndpoints {
  GET_UPLOAD_URL = '/files/upload-url',
  GENERATE_REPORT = '/api/v1/report/generate',
  UPLOAD_FILE = '/files/upload-file',
  AUDIT_REPORTS = '/audits',
  AUDIT_REPORTS_STATUS = '/status'
}
